import { useTranslation } from "@i18n";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import React, { useState } from "react";

type ImportSignatureProps = {
  handleSignDocChange?: (args: { base64ImageStr: string; fileType?: string }) => void;
  acceptFileType?: string;
};

function ImportSignature({ handleSignDocChange, acceptFileType }: ImportSignatureProps) {
  const { t } = useTranslation();
  /** The picked file once one is chosen; `false` is the nothing-picked sentinel. */
  const [selectedFile, setSelectedFile] = useState<File | false>(false);

  const fileToBase64 = async (file: File) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // `readAsDataURL` always produces a `data:` URL string; narrow instead of trusting the union.
        if (typeof reader.result === "string") {
          resolve(reader.result);
        } else {
          reject(new Error("Signature file could not be read as a data URL"));
        }
      };
      reader.onerror = (e) => reject(e);
    });

  const importFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const base64ImageStr = await fileToBase64(file);
      const fileType = file.type;

      setSelectedFile(file);
      handleSignDocChange!({ base64ImageStr, fileType });
    }
  };

  return (
    <div>
      <label htmlFor="signatureImage">
        <input
          type="file"
          name="signDoc"
          id="signatureImage"
          className="hidden"
          accept={acceptFileType ?? "image/png,image/jpg,image/jpeg,application/pdf"}
          onChange={importFile}
        />

        <div className="relative flex items-center justify-between gap-4 border border-[#c6d0df] px-4 py-2 cursor-pointer">
          <div className="pointer-events-none">
            <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>{t("Choose File")}</ButtonComponent>
          </div>
          <span className="text-sm">{!selectedFile ? "No File Chosen" : selectedFile.name}</span>
        </div>
      </label>
    </div>
  );
}

export default ImportSignature;
